import { Editable as ChakraEditable } from '@chakra-ui/react';
import * as React from 'react';

export interface EditableProps extends ChakraEditable.RootProps {
  rootRef?: React.Ref<HTMLDivElement>;
}

export const Editable = React.forwardRef<HTMLInputElement, EditableProps>(
  function Editable(props, ref) {
    const { children, rootRef, ...rest } = props;

    return (
      <ChakraEditable.Root ref={rootRef} {...rest}>
        {children}
      </ChakraEditable.Root>
    );
  }
);

Editable.displayName = 'Editable';

// Export sub-components for composition
export const EditablePreview = ChakraEditable.Preview;
export const EditableInput = ChakraEditable.Input;
export const EditableTextarea = ChakraEditable.Textarea;
export const EditableControl = ChakraEditable.Control;
export const EditableEditTrigger = ChakraEditable.EditTrigger;
export const EditableCancelTrigger = ChakraEditable.CancelTrigger;
export const EditableSubmitTrigger = ChakraEditable.SubmitTrigger;

// Export namespace for better DX
export const EditableRoot = ChakraEditable.Root;
export const EditableArea = ChakraEditable.Textarea;
